import React from 'react';

export default class Divider extends React.Component {
  render() {
    return (
      <div className="divider">
        <div className="start" />
        <div className="mid" />
        <div className="end" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/common/divider/divider.es6